import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem("geodir_Token"),
    store_builder: {
      team: "",
      map: "",
    },
    user: {},
    map: {},
    openSidenav: "",
    fieldsDirection: {
      ubigeo: "",
      nameVia: "",
      tipoVia: 0,
      numberVia: 0,
      nameUrbanization: "",
      tipoNucleo: "",
      manzana: "",
    },
    mapselected: null,
    layerselected: null,
    layerMarkerSearcher: null,
    layerMarkerBuildingsSearcher: null,
    layerPolygonSearcher: null,

    layersBuilder: null,

    query: "",
    markerSearcherReverse: null,

    latitud_general: "",
    longitud_general: "",
    place_id: "YTQxMWNmMTItZjZhNC01YmY5LWI2NjctMWE3Nzk3NGI1YmI2",
    address: "",
  },
  getters: {
    isLoggedIn: (state) => () => state.isLoggedIn,
    isOpenSidenav: (state) => () => state.openSidenav,
    //Direction
    store_getUbigeo: (state) => () => state.fieldsDirection.ubigeo,
    ubigeo(state) {
      return state.fieldsDirection.ubigeo;
    },
    via(state) {
      return state.fieldsDirection.nameVia;
    },
    tipoVia(state) {
      return state.fieldsDirection.tipoVia;
    },
    nucleoUrbano(state) {
      return state.fieldsDirection.nameUrbanization;
    },
    tipoNucleoUrbano(state) {
      return state.fieldsDirection.tipoNucleo;
    },
    layerMarkerSearcher(state) {
      return state.layerMarkerSearcher;
    },
    layerMarkerBuildingsSearcher(state) {
      return state.layerMarkerBuildingsSearcher;
    },
    layerPolygonSearcher(state) {
      return state.layerPolygonSearcher;
    },
    layersBuilder(state) {
      return state.layersBuilder;
    },
    userData(state) {
      return state.user;
    },
    getLatitudGeneral() {
      return state.latitud_general;
    },
    getLongitudGeneral() {
      return state.longitud_general;
    },
    getPlaceId() {
      return state.place_id;
    },
    getAddress() {
      return state.address;
    },
  },
  mutations: {
    store_setMap(state, map) {
      state.map = map;
    },
    SET_PLACE_ID(state, place_id) {
      state.place_id = place_id;
    },
    SET_ADDRESS(state, address) {
      state.address = address;
    },
    SET_LATITUD_GENERAL(state, latitud) {
      state.latitud_general = latitud;
    },
    SET_LONGITUD_GENERAL(state, longitud) {
      state.longitud_general = longitud;
    },
    SET_TEAM_OF_BUILDER: function(state, team) {
      state.store_builder.team = team;
    },
    SET_MAP_OF_BUILDER: function(state, map) {
      state.store_builder.map = map;
    },
    SET_SIDENAV: function(state, sidenav) {
      state.openSidenav = sidenav;
    },
    SET_VIA_DIRECTION: function(state, via) {
      state.fieldsDirection.nameVia = via;
    },
    SET_TIPO_VIA_DIRECTION: function(state, tipoVia) {
      state.fieldsDirection.tipoVia = tipoVia;
    },
    SET_NU_DIRECTION: function(state, nameNu) {
      state.fieldsDirection.nameUrbanization = nameNu;
    },
    SET_TIPO_NU_DIRECTION: function(state, tipoNu) {
      state.fieldsDirection.tipoNucleo = tipoNu;
    },
    store_setUbigeo: function(state, ubigeo) {
      state.fieldsDirection.ubigeo = ubigeo;
    },
    SET_MAP_SELECT: function(state, map) {
      state.mapselected = map;
    },
    SET_LAYER_SELECT: function(state, layer) {
      state.layerselected = layer;
    },
    SET_LAYER_MARKER: function(state, layer) {
      state.layerMarkerSearcher = layer;
    },
    SET_LAYER_MARKER_BUILDINGS: function(state, layer) {
      state.layerMarkerBuildingsSearcher = layer;
    },
    SET_GEOJSON_MARKER: function(state, layer) {
      state.layerPolygonSearcher = layer;
    },
    SET_LAYERS_BUILDER: function(state, layer) {
      state.layersBuilder = layer;
    },
    setQuery(state, query) {
      state.query = query;
    },
    setMarkerSearcherReverse(state, marker) {
      state.markerSearcherReverse = marker;
    },
  },
  actions: {},
});
